<template>
  <div class="form__field">
    <div class="form__control">
      <input
        type="checkbox"
        v-model="value"
        :id="identifier"
        :name="identifier"
        :value="field.value"
        :false-value="field.valueFalse"
        :true-value="field.valueTrue"
      />
      <label class="form__checkbox" :for="identifier">
        <span class="form__checkbox__indicator icon-check"></span>
        <span v-html="field.label"></span>
      </label>
    </div>
    <div
      class="form__message form__message form__message--error"
      v-show="field.error"
    >
      {{ field.error }}
    </div>
    <div class="form__description" v-show="field.description">
      {{ field.description }}
    </div>
  </div>
</template>

<script>
import * as Components from ".";

export default {
  extends: Components.CheckoutField,
  name: "checkout-field-checkbox",
  computed: {
    identifier: function() {
      return this.field.path.join("_");
    },
    value: {
      get() {
        return this.field.value;
      },
      set(value) {
        this.$store.dispatch("updateField", {
          field: this.field,
          newProps: { value: value }
        });
      }
    }
  },
  methods: {
    validate: function() {
      this.$store.dispatch("validateField", {
        field: this.field
      });
    }
  }
};
</script>
